<script setup lang="ts">
import { cn } from "@/lib/utils";
import type { FrontContent } from "@gasparigit/omnia-sdk";
import { getContentType, link } from "~/lib/utils/contents";
import type { CreateLinkConfig } from "~/utils/types";

defineProps<{
  content: FrontContent;
  compact?: boolean;
  showAreas?: boolean;
  infoLabel?: string;
  linkConfig?: CreateLinkConfig;
}>();
</script>

<template>
  <FrontContentItemsBaseItem
    v-bind="$props"
    :class="$attrs?.class"
    :title="content.title"
    :abstract="content.abstract"
    :info-label="infoLabel || getContentType(content)"
    :areas="content.areas"
    :date="content.published_at || content.created_at"
    :link="linkConfig ? link({ ...linkConfig, content }) : undefined"
  >
    <template v-if="content.visibility === 'users'" #pre-header>
      <div :class="cn('flex mb-2', !compact && 'justify-end')">
        <FrontShareModal :shareable="content">
          <template #trigger>
            <Button
              variant="default"
              size="sm"
              class="text-sm px-2 py-0.5 h-auto"
            >
              Condividi
            </Button>
          </template>
        </FrontShareModal>
      </div>
    </template>
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
  </FrontContentItemsBaseItem>
</template>
